import React from "react";
import { observer } from "mobx-react";
import { computed, observable } from "mobx";

import { Button, Typography } from "@material-ui/core";

import Row from "components/Form/Row";
import Dropdown from "components/Input/Dropdown";

import { DictionaryItem } from "constants/models";

import {
  Container,
  Buttons,
  ButtonContainer,
  TitleContainer,
  SubtitleContainer,
} from "./styles";

type Props = {
  options: Array<DictionaryItem>;
  onClose: () => void;
  onSave: (newTags: any) => void;
};

@observer
class TagsForm extends React.Component<Props> {
  @observable newTags: DictionaryItem[] = [];

  @computed get newTagValue() {
    return this.newTags?.map(item => item.value);
  }

  onChangeNewTags = (items: DictionaryItem[] = []) => {
    this.newTags = items;
  };

  onSaveNewTags = () => {
    this.props.onSave(this.newTags);
  };

  render() {
    const { onClose, options } = this.props;

    return (
      <>
        <Container>
          <Row>
            <TitleContainer>
              <Typography variant="h1" color="textPrimary">
                Add Tags
              </Typography>
              {!!this.newTags.length && (
                <SubtitleContainer>
                  <Typography variant="subtitle1" color="textPrimary">
                    {`${this.newTags.length} items selected`}
                  </Typography>
                </SubtitleContainer>
              )}
            </TitleContainer>
          </Row>

          <Row>
            <Dropdown
              input={{ value: this.newTagValue }}
              options={options}
              onChange={this.onChangeNewTags}
              multi
              multiTagMode
              isClearable
              searchable
            />
          </Row>
        </Container>

        <Buttons>
          <ButtonContainer>
            <Button
              variant="outlined"
              color="primary"
              onClick={onClose}
              fullWidth
            >
              Cancel
            </Button>
          </ButtonContainer>
          <ButtonContainer>
            <Button
              variant="contained"
              color="primary"
              onClick={this.onSaveNewTags}
              fullWidth
            >
              Save
            </Button>
          </ButtonContainer>
        </Buttons>
      </>
    );
  }
}

export default TagsForm;
